import { render, staticRenderFns } from "./MyPersonalLoan.vue?vue&type=template&id=2de670f0&"
import script from "./MyPersonalLoan.vue?vue&type=script&lang=js&"
export * from "./MyPersonalLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports